import userInfo from 'hub-http/userInfo';
import BaseApplication from '../BaseApplication';
export default class HubfulApplication extends BaseApplication {
  // @ts-expect-error ts-migrate(2425) FIXME: Class 'BaseApplication' defines instance member pr... Remove this comment to see the full error message
  loadUserHubInfo() {
    return userInfo();
  }

  // @ts-expect-error ts-migrate(2425) FIXME: Class 'BaseApplication' defines instance member pr... Remove this comment to see the full error message
  getBaseName() {
    const {
      portal
    } = this.authConfig;
    if (window.location && window.location.href.indexOf('settings') > -1) {
      return `/settings/${portal.portal_id}/user-preferences`;
    }
    return `/user-preferences/${portal.portal_id}`;
  }
}